export default {
  date: '',
  file: '',
}